module.exports = __webpack_public_path__ + "img/Logo-Sem-Fundo-WINFIT-AGRO.3ac73ed9.png";